import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHeroBackground } from '@/hooks/useHeroBackground';

interface HeroBackgroundGradientProps {
  children: React.ReactNode;
}

export const HeroBackgroundGradient: React.FC<HeroBackgroundGradientProps> = ({ children }) => {
  const location = useLocation();
  const { settings, loading } = useHeroBackground();
  
  // Só aplica o degradê na página inicial quando há imagem de fundo
  const isHomePage = location.pathname === '/';
  const shouldShowGradient = isHomePage && settings?.background_image_url && !loading;

  return (
    <div className="relative">
      {/* Degradê aplicado sobre esta seção com transição ULTRA SUAVE */}
      {shouldShowGradient && (
        <>
          {/* Gradient Layer 1 - TRANSIÇÃO ULTRA INTENSIVA */}
          <div 
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `linear-gradient(
                to bottom, 
                rgba(12, 17, 23, 0.99) 0%, 
                rgba(12, 17, 23, 0.995) 1%, 
                rgba(12, 17, 23, 0.998) 2%, 
                rgba(12, 17, 23, 0.999) 3%, 
                rgba(12, 17, 23, 1) 5%
              )`,
              zIndex: 1,
            }}
          />
          
          {/* Gradient Layer 2 - REFORÇO TOTAL */}
          <div 
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `linear-gradient(
                to bottom, 
                rgba(12, 17, 23, 0.95) 0%, 
                rgba(12, 17, 23, 0.97) 2%, 
                rgba(12, 17, 23, 0.98) 4%, 
                rgba(12, 17, 23, 0.99) 6%, 
                rgba(12, 17, 23, 0.995) 8%, 
                rgba(12, 17, 23, 0.998) 10%, 
                rgba(12, 17, 23, 1) 15%
              )`,
              zIndex: 2,
            }}
          />
          
          {/* Gradient Layer 3 - GARANTIA MÁXIMA */}
          <div 
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `linear-gradient(
                to bottom, 
                rgba(12, 17, 23, 0.9) 0%, 
                rgba(12, 17, 23, 0.95) 5%, 
                rgba(12, 17, 23, 0.98) 10%, 
                rgba(12, 17, 23, 0.99) 15%, 
                rgba(12, 17, 23, 1) 20%
              )`,
              zIndex: 3,
            }}
          />

          {/* Gradient Layer 4 - COBERTURA TOTAL */}
          <div 
            className="absolute inset-0 pointer-events-none"
            style={{
              background: `rgba(12, 17, 23, 1)`,
              zIndex: 4,
            }}
          />
        </>
      )}
      
      {/* Conteúdo da seção */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}; 